import { GameAssets, GameParams } from "@spawn/core";
import { SymbolService as CoreSymbolService, NrgGameDiProject } from "@spawn/nrg-games-core";
import { Assets } from "./assets";
import { Params } from "./params";
import { SymbolService } from "./services/symbolService";

export class GameDiProject extends NrgGameDiProject {
	public override configure(): void {
		// Shared services of all games, see NrgGameDiProject.
		super.configure();

		this.override(CoreSymbolService, SymbolService);
		this.override(GameParams, Params);
		this.override(GameAssets, Assets);
	}
}
